import React, {FC} from 'react';
import { ContainerStyled, BodyStyled, IconStyled } from "./style"
import icon from 'assets/img/x-icon-black.svg';

interface DarkAlertProps {
    message: string;
    isOpen: boolean;
    onClose: () => void;
}

const DarkAlert: FC<DarkAlertProps> = ({ message, onClose, isOpen }) => {
    return (
        <ContainerStyled show={isOpen}>
            <BodyStyled>{message}</BodyStyled>
            <IconStyled src={icon} onClick={onClose} />
        </ContainerStyled>
    )
}

export default DarkAlert;